document.addEventListener("DOMContentLoaded", function() {
    const params = window.location.search;
    window.urlParams = params
    if (params) {
        const parentDiv = document.querySelector('.c-product-hero__controls');
        if (parentDiv) {
            const heroButton = parentDiv.querySelector('a');
            console.log(heroButton);
            if (heroButton) {
                const originalHref = heroButton.getAttribute("href").split('?')[0]; // elimina antiguos parámetros si los hubiera
                heroButton.setAttribute("href", originalHref + params);
            }
        }
    }
});